import { createContext } from 'react';

export const DarkModeContext = createContext({
  isDarkMode: false,
  toggleDarkMode: (_e?: React.MouseEvent | React.KeyboardEvent) => {},
});
